module.exports = __webpack_public_path__ + "static/media/mblBGlogo.44d3b826.svg";